export const NOTE_LIST_ATTEMPT = "NOTE_LIST_ATTEMPT";
export const NOTE_LIST_SUCCESS = "NOTE_LIST_SUCCESS";
export const NOTE_LIST_FAILED = "NOTE_LIST_FAILED";
////////////
export const NOTE_MORELIST_ATTEMPT = "NOTE_MORELIST_ATTEMPT";
export const NOTE_MORELIST_SUCCESS = "NOTE_MORELIST_SUCCESS";
export const NOTE_MORELIST_FAILED = "NOTE_MORELIST_FAILED";
////////////
export const NOTE_NEW_SUCCESS = "NOTE_NEW_SUCCESS";
export const NOTE_NEW_FAILED = "NOTE_NEW_FAILED";
//////////////////////
export const NOTE_UPDATE_SUCCESS = "NOTE_UPDATE_SUCCESS";
export const NOTE_UPDATE_HIDE_SUCCESS = "NOTE_UPDATE_HIDE_SUCCESS";
export const NOTE_SET_ITEM = "NOTE_SET_ITEM";
////////////
export const NOTE_REMOVE_SUCCESS = "NOTE_REMOVE_SUCCESS";
export const NOTE_REMOVE_FAILED = "NOTE_REMOVE_FAILED";





